import { Environment } from './environment.types';

export const environment: Environment = {
  baseApiUrl: 'https://api.rental.development.connexionmobility.com',
  dealerBaseApiUrl: 'https://dev-api.cxztrac.com',
  dealerApiKey: 'tEmD9RVvL9aWkzGtnBu287hoiQQMRgfL1K40OsQs',
  customerApiKey: 'u42QNy6hmrTi6gzYtduUgWxVxT2zwidqIThE064I',
  vehicleApiKey: 'aWYbTwN1bQZaJwFTWKTtjoXxEd0X0jdRJK9q5gSd',
  paymentApiKey: 'qB4eVc2gedUga8T8WQg5xGUXmVOd1QL2mI566HiI',
  minImgWidthPx: '800',
  minImgHeightPx: '400',
  licenseVerificationExpiryDays: '60',
};
